import { Extension } from '@tiptap/core';
import { Fragment, Slice } from '@tiptap/pm/model';
import { Plugin } from '@tiptap/pm/state';

export const DisallowWhitespace = Extension.create({
  name: 'disallowWhitespace',
  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: {
          handlePaste(view, event, _slice) {
            const pastedText = event.clipboardData?.getData('text/plain') || '';
            const withoutWhitespace = pastedText.replaceAll(/\s+/g, '');
            const textNode = view.state.schema.text(withoutWhitespace);
            const newSlice = new Slice(Fragment.from(textNode), 0, 0);
            const transaction = view.state.tr.replaceSelection(newSlice);

            view.dispatch(transaction);

            return true;
          },
        },
        filterTransaction: (transaction, _state) => {
          const { doc } = transaction;

          // blocks creation of new lines
          if (doc.content.childCount > 1) {
            return false;
          }

          // blocks creation of trailing whitespace
          if (doc.textContent.match(/.*\s$/)) {
            return false;
          }

          return true;
        },
      }),
    ];
  },
});